import React from 'react';
import Banner from './Banner';
import Services from './Services';
import WhyChoose from './WhyChoose';
import Counter from './Counter';
import Process from './Process'
import ProjectTwo from './ProjectTwo';
import Testimonial from './Testimonial';
import Blog from './Blog';
import GoogleMap from './GoogleMap';


const HomeTwoMain = () => {
	return (
		<>
			<Banner />
			<Services />
			<WhyChoose />
			<Counter />
			<Process />
			<ProjectTwo />
			<Testimonial />
			<Blog />
			<GoogleMap />
		</>
	);
}

export default HomeTwoMain;
